module.exports = (angularModule) => angularModule.controller('ConfirmDeleteAccountCtrl',
  ($scope, $uibModalInstance, accountsService, account) => {


    Object.assign($scope, {
      loading: true,
      account,
      resolve() {
        $uibModalInstance.close()
      },
      reject() {
        $uibModalInstance.dismiss()
      }
    })

    $scope.countTypes = [
      'locations',
      'users',
      'groups'
    ]

    $scope.summarizeCount = (countType) => {
      const total = $scope.counts[countType].total;
      const capitalized = countType.charAt(0).toUpperCase() + countType.slice(1);
      return total + ' ' + capitalized;
    }
    $scope.detailsVisible = {}
    $scope.toggleShowDetails = (countType) => {
      $scope.detailsVisible[countType] = !$scope.detailsVisible[countType]
    }


    function getAccountDetails() {
      accountsService.getAccountEntityDetails(account.id).then(
        (counts) => {
          $scope.loading = false;
          $scope.counts = counts
        })
    }
    getAccountDetails()
});
